import { render, staticRenderFns } from "./attr-setupInfo.vue?vue&type=template&id=0e0b3a2e&scoped=true"
import script from "./attr-setupInfo.vue?vue&type=script&lang=js"
export * from "./attr-setupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0b3a2e",
  null
  
)

export default component.exports